import { useNavigate, useParams } from "react-router";
import { useStoreState } from "../../store";
import { useAuth } from "../../utility/useAuth";
import { useEffect, useState } from "react";
import {
  LabelText,
  SmallLabelText,
  StyledCncCardVisualInspectionPage,
  TitleLabelText,
} from "./CncCardVisualInspectionPage.styles";
import { Col, Container, Row } from "react-grid-system";
import {
  ButtonComponent,
  CheckBoxComponent,
} from "@syncfusion/ej2-react-buttons";
import AsyncModal from "../../components/Modals/AsyncModal/AsyncModal";
import { BarCodeScannerPanel } from "../../components/BarCodeScannerPanel/BarCodeScannerPanel";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import { InpectionItem } from "../../types/reportChecklists/InspectionItem";
import { InspectionStatusType } from "../../types/reportChecklists/InspectionStatusType";
import { shortDateFormat } from "../../utility/dateHelpers";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Inject,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { RecomendationType } from "../../types/reportChecklists/RecomendationType";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";
import {
  createTicket,
  getDocumentContent,
  getDocuments,
  getOption,
  getUsers,
  lockAction,
  printTemplate,
  sendEmail,
  unlockAction,
  uploadDocument,
} from "../../services/ApiService";
import { InspectorRole } from "../../types/InspectorRole";
import { CncCardVisualInspectionReport } from "../../types/reportChecklists/CncCardVisualInspectionReport";
import { PrintRequest } from "../../types/PrintRequest";
import { EmailMessage } from "../../types/EmailMessage";
import { Ticket } from "../../types/reportChecklists/Ticket";

export const CncCardVisualInspectionPage: React.FC = () => {
  const auth = useAuth();
  const user = useStoreState((state) => state.user);
  const { sequence } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [pugseyTestReportNumber, setPugseyTestReportNumber] =
    useState<string>();
  const [amobProductionNumber, setAmobProductionNumber] = useState<string>();
  const [partNumber, setPartNumber] = useState<string>();
  const [heatCode, setHeatCode] = useState<string>();
  const [sequenceNumber, setSequenceNumber] = useState<string>();
  const [batch, setBatch] = useState<number>(1);
  const [iteration, setIteration] = useState<string>("A");
  const [status, setStatus] = useState<string>();
  const [quantity, setQuantity] = useState<number>(1);
  const [toolSize, setToolSize] = useState<string>();
  const [tubeLenght, setTubeLenght] = useState<string>();
  const [bentTubeCheckListItems, setBentTubeCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [preBendCheckListItems, setPreBendCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [
    firstCellMeasurmentCheckListItems,
    setFirstCellMeasurmentCheckListItems,
  ] = useState<InpectionItem[]>([]);
  const [
    lastCellMeasurmentCheckListItems,
    setLastCellMeasurmentCheckListItems,
  ] = useState<InpectionItem[]>([]);
  const [
    fullBatchMeasurmentCheckListItems,
    setFullBatchMeasurmentCheckListItems,
  ] = useState<InpectionItem[]>([]);
  const [
    postProductionCleaningCheckListItems,
    setPostProductionCleaningCheckListItems,
  ] = useState<InpectionItem[]>([]);

  const [
    firstCellMeasurementReportNumber,
    setFirstCellMeasurementReportNumber,
  ] = useState<string>();
  const [lastCellMeasurementReportNumber, setLastCellMeasurementReportNumber] =
    useState<string>();
  const [
    fullBatchMeasurementReportNumber,
    setFullBatchMeasurementReportNumber,
  ] = useState<string>();

  const [recommendation, setRecommendation] = useState<string>();

  const [nonConformanceReportRef, setNonConformanceReportRef] =
    useState<string>();

  const [inspectorSignature, setInspectorSignature] = useState<string>();
  const [inspectorSignDate, setInspectorSignDate] = useState<Date | undefined>(
    undefined
  );
  const [qualityRepresentiveSignature, setQualityRepresentiveSignature] =
    useState<string>();
  const [qualityRepresentiveSignDate, setQualityRepresentiveSignDate] =
    useState<Date | undefined>(undefined);
  const [warehouseRepresentiveSignature, setWarehouseRepresentiveSignature] =
    useState<string>();
  const [warehouseRepresentiveSignDate, setWarehouseRepresentiveSignDate] =
    useState<Date | undefined>(undefined);
  const [canSumbit, setCanSubmit] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState<boolean>(false);

  const [printerName, setPrinterName] = useState<string>();
  const [lockInspectionMinutes, setLockInspectionMinutes] =
    useState<number>(10);

  let btnScanPartNumber: ButtonComponent | null;
  let btnPugseyTestReportNumber: ButtonComponent | null;
  let btnAmobProductionNumber: ButtonComponent | null;
  // let btnScanHeatCode: ButtonComponent | null;

  const reportType = "cnc-route-card-visual-inspection";
  const reportDescription = "CNC Route card visual inspection";

  const recomendations = [
    RecomendationType[RecomendationType.TotalRejection],
    RecomendationType[RecomendationType.PartialRejection],
    RecomendationType[RecomendationType.LocalRework],
    RecomendationType[RecomendationType.Approval],
  ];

  const bentTubeCheckList = [
    "15mm from both tube ends have been cut off",
    "Tube length defined as per part number drawing in AMOB",
    "Tube length is free from scratches / dents / damage ",
    "Tube is free from burs inside and out, the end is square and there are no sharp edges",
    "Tube is free from flattening, wall thinning, ovality and buckling or wrinkling",
    "Tube is free from swarth inside ",
    "Liquid penetrant check required, if doubt exists ",
  ];

  const preBendCheckList = [
    "3 min rinse clean to remove potential contamination from tube cutter",
  ];

  const measurmentCheckList = ["Green", "Red (Rotation / Length / Angle)"];

  const postProductionCleaningCheckList = [
    "Flushed clean",
    "Washed using deionised water",
    "Visual inspection to ensure contamination free",
    "Visual examination to check discolouration",
  ];

  useEffect(() => {
    const bentTubeItems = bentTubeCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setBentTubeCheckListItems(bentTubeItems);

    const preBendItems = preBendCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setPreBendCheckListItems(preBendItems);

    const firstCellMeasurmentCheckListItems = measurmentCheckList.map(
      (v, i) => {
        return { seq: i + 1, text: v, status: "" } as InpectionItem;
      }
    );
    setFirstCellMeasurmentCheckListItems(firstCellMeasurmentCheckListItems);

    const lastCellMeasurmentCheckListItems = measurmentCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setLastCellMeasurmentCheckListItems(lastCellMeasurmentCheckListItems);

    const fullBatchMeasurmentCheckListItems = measurmentCheckList.map(
      (v, i) => {
        return { seq: i + 1, text: v, status: "" } as InpectionItem;
      }
    );
    setFullBatchMeasurmentCheckListItems(fullBatchMeasurmentCheckListItems);

    const postProductionCleaningCheckListItems =
      postProductionCleaningCheckList.map((v, i) => {
        return { seq: i + 1, text: v, status: "" } as InpectionItem;
      });
    setPostProductionCleaningCheckListItems(
      postProductionCleaningCheckListItems
    );

    setInspectorSignature(user.info.name ?? user.fullName);
    setInspectorSignDate(new Date());

    getOption(auth, `LabelPrinter:${user.info.printLocation}`).then(
      (option) => {
        setPrinterName(option);
      }
    );

    getOption(auth, `LockInspectionMinutes`).then((option) => {
      if (option) {
        setLockInspectionMinutes(Number(option));
      }
    });
  }, []); // eslint-disable-line

  useEffect(() => {
    if (sequence) {
      if (
        user.info.inspection !==
          InspectorRole[InspectorRole.QualityRepresentive] &&
        user.info.inspection !==
          InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setError(
          "You need to be Quality or Warehouse Representive to countersign the report."
        );
        return;
      }

      if (
        user.info.inspection ===
        InspectorRole[InspectorRole.QualityRepresentive]
      ) {
        setQualityRepresentiveSignature(user.info.name ?? user.fullName);
        setQualityRepresentiveSignDate(new Date());
      } else if (
        user.info.inspection ===
        InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setWarehouseRepresentiveSignature(user.info.name ?? user.fullName);
        setWarehouseRepresentiveSignDate(new Date());
      }

      loadReport(sequence, false);
    }
  }, [sequence]);

  useEffect(() => {
    if (partNumber) {
      const sequenceNumber = `${partNumber}-${batch}-${iteration}${
        status ? `-${status}` : ""
      }`;
      setSequenceNumber(sequenceNumber);
    }
  }, [partNumber, batch, iteration, status]);

  useEffect(() => {
    const bentTubeStatus = validateItems(bentTubeCheckListItems);
    const preBendStatus = validateItems(preBendCheckListItems);
    const firstCellStatus = validateItems(firstCellMeasurmentCheckListItems);
    const lastCellStatus = validateItems(lastCellMeasurmentCheckListItems);
    const fullBatchStatus = validateItems(fullBatchMeasurmentCheckListItems);
    const postProductionStatus = validateItems(
      postProductionCleaningCheckListItems
    );
    setStatus(undefined);
    setCanSubmit(false);
    if (
      !amobProductionNumber ||
      !heatCode ||
      !pugseyTestReportNumber ||
      !toolSize ||
      !tubeLenght ||
      !firstCellMeasurementReportNumber ||
      !lastCellMeasurementReportNumber ||
      !fullBatchMeasurementReportNumber
    ) {
      return;
    }
    if (
      bentTubeStatus === true &&
      preBendStatus === true &&
      firstCellStatus === true &&
      lastCellStatus === true &&
      fullBatchStatus === true &&
      postProductionStatus === true &&
      partNumber &&
      recommendation === RecomendationType[RecomendationType.Approval]
    ) {
      setStatus("P");
      setCanSubmit(true);
    }
    if (
      partNumber &&
      (bentTubeStatus === false ||
        preBendStatus === false ||
        firstCellStatus === false ||
        lastCellStatus === false ||
        fullBatchStatus === false ||
        postProductionStatus === false) &&
      (recommendation === RecomendationType[RecomendationType.TotalRejection] ||
        iteration === "D")
    ) {
      setStatus("F");
      setCanSubmit(true);
    } else if (
      partNumber &&
      (bentTubeStatus === false ||
        preBendStatus === false ||
        firstCellStatus === false) &&
      (recommendation ===
        RecomendationType[RecomendationType.PartialRejection] ||
        recommendation === RecomendationType[RecomendationType.LocalRework])
    ) {
      setStatus("R");
      setCanSubmit(true);
    }
  }, [
    pugseyTestReportNumber,
    amobProductionNumber,
    partNumber,
    heatCode,
    toolSize,
    tubeLenght,
    bentTubeCheckListItems,
    preBendCheckListItems,
    firstCellMeasurmentCheckListItems,
    lastCellMeasurmentCheckListItems,
    fullBatchMeasurmentCheckListItems,
    postProductionCleaningCheckListItems,
    firstCellMeasurementReportNumber,
    lastCellMeasurementReportNumber,
    fullBatchMeasurementReportNumber,
    recommendation,
  ]);

  const scanPartNumberClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      try {
        await lockAction(
          auth,
          `${dataResult} ${reportDescription}`,
          lockInspectionMinutes
        );
      } catch (error: any) {
        setError(`${error.response.data}`);
        return;
      }

      const batch = await getPartNumberBatch(dataResult);
      if (batch[0]) {
        setBatch(batch[0]);
      } else if (batch[1]) {
        loadReport(`${dataResult}-${batch[1]}`, true);
      }

      setPartNumber(dataResult);
    }
  };

  const scanPudseyTestClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      setPugseyTestReportNumber(dataResult);
    }
  };

  const scanAmobProductionNumberClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      if (isNaN(Number(dataResult))) {
        ToastUtility.show(
          `The Production Order should be numeric`,
          "Error",
          2000
        );
        return;
      }
      setAmobProductionNumber(dataResult);
    }
  };

  function handleError(error: any, prefix?: string) {
    const message = `${prefix} Error: ${error}`;
    console.error(message);
    ToastUtility.show(message, "Error", 2000);
  }

  async function getReport(
    partNumber: string,
    report: string
  ): Promise<CncCardVisualInspectionReport | undefined> {
    try {
      const result = await getDocumentContent(
        auth,
        `${reportType}-reports-${partNumber}`,
        report
      );
      return JSON.parse(await result.text()) as CncCardVisualInspectionReport;
    } catch (error) {
      handleError(error, "Failed to retrieve report");
    }
    return undefined;
  }

  async function getPartNumberBatch(
    partNumber: string
  ): Promise<[number | undefined, string | undefined]> {
    try {
      const reports = (
        await getDocuments(
          auth,
          undefined,
          `${reportType}-reports-${partNumber.toLowerCase()}`,
          true
        )
      ).map((d) => {
        return {
          batch: Number(d.split("\\")[1].split("-")[0]),
          iteration: d.split("\\")[1].split("-")[1],
          status: d.split("\\")[1].split("-")[2],
        };
      });
      //const maxBatch = Math.max(...reports.map((o) => o.batch), 0);
      if (reports?.length > 0) {
        const lastReport = reports.reduce(
          ([max], item) => [
            max.batch * 100 + max.iteration.charCodeAt(0) <
            item.batch * 100 + item.iteration.charCodeAt(0)
              ? item
              : max,
          ],
          [reports[0]]
        );

        if (lastReport?.length > 0 && lastReport[0].status === "r") {
          return [
            undefined,
            `${lastReport[0].batch}-${lastReport[0].iteration}-${lastReport[0].status}`,
          ];
        }

        return [lastReport[0].batch + 1, undefined];
      }

      //return Math.max(...reports.map((o) => o.batch), 0) + 1;
    } catch (error) {
      handleError(error, "Failed to get reports");
    }
    return [1, undefined];
  }

  const printLabel = async (report: CncCardVisualInspectionReport) => {
    if (!printerName) {
      return;
    }

    const substr: {
      [key: string]: string;
    } = {};

    Object.entries(report).forEach(
      ([key, value]) =>
        (substr[`Report.${key}`] =
          value instanceof Date === true
            ? shortDateFormat(value?.toString() ?? "")
            : value.toString() ?? "")
    );

    console.log(JSON.stringify(substr));

    const request: PrintRequest = {
      templateName: `templates-labelprinter\\cnccardvisualinspectionreport.xml`,
      substrings: substr,
      noLabels: 1,
      printerName: printerName,
      location: user.info.printLocation,
    };

    try {
      const data = await printTemplate(auth, request);
      ToastUtility.show("The print job sent to the spooler.", "Info", 2000);
    } catch (error) {
      handleError(error, "Failed to print label operation.");
    }
  };

  const onSubmit = async (event: any) => {
    const report: CncCardVisualInspectionReport = {
      pugseyTestReportNumber: pugseyTestReportNumber ?? "",
      amobProductionNumber: amobProductionNumber ?? "",
      partNumber: partNumber ?? "",
      heatCode: heatCode ?? "",
      quantity: quantity,
      toolSize: toolSize ?? "",
      tubeLenght: tubeLenght ?? "",
      bentTubeCheckListItems: bentTubeCheckListItems,
      preBendCheckListItems: preBendCheckListItems,
      firstCellMeasurmentCheckListItems: firstCellMeasurmentCheckListItems,
      lastCellMeasurmentCheckListItems: lastCellMeasurmentCheckListItems,
      fullBatchMeasurmentCheckListItems: fullBatchMeasurmentCheckListItems,
      postProductionCleaningCheckListItems:
        postProductionCleaningCheckListItems,
      firstCellMeasurementReportNumber: firstCellMeasurementReportNumber ?? "",
      lastCellMeasurementReportNumber: lastCellMeasurementReportNumber ?? "",
      fullBatchMeasurementReportNumber: fullBatchMeasurementReportNumber ?? "",
      recommendation: recommendation ?? "",
      //nonConformanceReportRef: nonConformanceReportRef,
      //reworkDescription: reworkDescription,
      inspectorSignature: inspectorSignature ?? "",
      inspectorSignDate: inspectorSignDate ?? new Date(),
    };

    if (
      !nonConformanceReportRef &&
      recommendation === RecomendationType[RecomendationType.TotalRejection]
    ) {
      const ticket: Ticket = {
        subject: `FAILED TUBE SET ${partNumber}-${batch}-${iteration}`,
        content: "The total rejection of the part number sequence",
      };
      report.nonConformanceReportRef = await createTicket(auth, ticket);
    }

    const blob = new Blob([JSON.stringify(report, null, 2)], {
      type: "application/json",
    });

    const reportName = `${batch}-${iteration}${status ? `-${status}` : ""}`;

    try {
      await uploadDocument(
        auth,
        `${reportType}-reports-${partNumber}`,
        reportName,
        blob
      );

      unlockAction(auth, `${partNumber}  ${reportDescription}`).catch(
        (error) => {
          handleError(error, "Failed to unlock the report");
          return;
        }
      );

      const needQualityRepSignature: boolean =
        !report.qualityRepresentiveSignature;
      const needWarehouseRepSignature: boolean =
        !report.warehouseRepresentiveSignature;
      if (status === "P") {
        await printLabel(report);

        if (needQualityRepSignature || needWarehouseRepSignature) {
          const users = (await getUsers(auth)).filter(
            (u) =>
              (needQualityRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.QualityRepresentive]) ||
              (needWarehouseRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.WarehouseRepresentive])
          );

          const subject = `Countersign ${reportName} report`;
          const body = `Dear Sir or Madam,<br/>Please countersign ${reportName} report.<br/>
          <a>https://csm.swagelokcentral.co.uk/${reportType}/${partNumber}-${reportName}</a>`;

          const currentUser = user.info.name ?? user.fullName;

          users.forEach((user) => {
            if (user.email && currentUser !== user.name) {
              try {
                let email: EmailMessage = {
                  subject: subject,
                  body: body,
                  to: [{ address: user.email }],
                };
                sendEmail(auth, email);
              } catch (emailError) {
                handleError(emailError, "Failed to send email");
              }
            }
          });
        }
      }
      navigate(`/barcode/${sequenceNumber?.toLowerCase()}`);
    } catch (error) {
      handleError(error, "Failed to submit report");
    }
  };

  function loadReport(sequence: string, rework: boolean) {
    if (
      sequence &&
      bentTubeCheckListItems &&
      preBendCheckListItems &&
      firstCellMeasurmentCheckListItems &&
      lastCellMeasurmentCheckListItems &&
      fullBatchMeasurmentCheckListItems &&
      postProductionCleaningCheckListItems
    ) {
      const parts = sequence.split("-");
      const partNumber = parts
        .slice(0, parts.length - 3)
        .join("-")
        .toUpperCase();
      const batch = Number(parts[parts.length - 3]);
      const iteration = parts[parts.length - 2].toUpperCase();
      const status = parts[parts.length - 1];
      const reportName = `${batch}-${iteration}-${status}`;

      const newIteration = rework
        ? String.fromCharCode(iteration.charCodeAt(0) + 1)
        : iteration;
      if (!rework) {
        lockAction(
          auth,
          `${partNumber} ${reportDescription}`,
          lockInspectionMinutes
        ).catch((error) => {
          setError(`${error.response.data}`);
          return;
        });
      }

      getReport(partNumber.toLowerCase(), reportName.toLowerCase()).then(
        (report) => {
          if (!report) {
            setError("Failed to load the report");
            return;
          }

          const signedBy = user.info.name ?? user.fullName;
          if (!rework && report?.inspectorSignature === signedBy) {
            setError(
              "You can't countersign the report that you already signed"
            );
            return;
          }

          //setPurchaseOrder(report?.purchaseOrder);
          setPugseyTestReportNumber(report?.pugseyTestReportNumber);
          setAmobProductionNumber(report.amobProductionNumber);
          setHeatCode(report?.heatCode);
          setQuantity(report?.quantity);
          setToolSize(report?.toolSize);
          setTubeLenght(report.tubeLenght);

          // Workaround for UI Grid issue
          if (
            report.bentTubeCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            bentTubeCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setBentTubeCheckListItems(
              report?.bentTubeCheckListItems ?? bentTubeCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.preBendCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            preBendCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setPreBendCheckListItems(
              report?.preBendCheckListItems ?? preBendCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.firstCellMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            firstCellMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setFirstCellMeasurmentCheckListItems(
              report?.firstCellMeasurmentCheckListItems ??
                firstCellMeasurmentCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.lastCellMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            lastCellMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setLastCellMeasurmentCheckListItems(
              report?.lastCellMeasurmentCheckListItems ??
                lastCellMeasurmentCheckListItems
            );
          }

          if (
            report.fullBatchMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            fullBatchMeasurmentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setFullBatchMeasurmentCheckListItems(
              report?.fullBatchMeasurmentCheckListItems ??
                fullBatchMeasurmentCheckListItems
            );
          }

          if (
            report.postProductionCleaningCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            postProductionCleaningCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setPostProductionCleaningCheckListItems(
              report?.postProductionCleaningCheckListItems ??
                postProductionCleaningCheckListItems
            );
          }

          setFirstCellMeasurementReportNumber(
            report.firstCellMeasurementReportNumber
          );
          setLastCellMeasurementReportNumber(
            report.lastCellMeasurementReportNumber
          );
          setFullBatchMeasurementReportNumber(
            report.fullBatchMeasurementReportNumber
          );

          setRecommendation(report?.recommendation);
          setNonConformanceReportRef(report?.nonConformanceReportRef);
          //setBatchIdentification(report?.batchIdentification);
          //setReworkDescription(report?.reworkDescription);
          //setRejectedQuantity(report?.rejectedQuantity);
          if (rework) {
            setInspectorSignature(user.info.name ?? user.fullName);
            setInspectorSignDate(new Date());
          } else {
            setInspectorSignature(report?.inspectorSignature);
            setInspectorSignDate(report?.inspectorSignDate);
          }

          if (report?.qualityRepresentiveSignature) {
            setQualityRepresentiveSignature(
              report?.qualityRepresentiveSignature
            );
            setQualityRepresentiveSignDate(report?.qualityRepresentiveSignDate);
          }

          if (report?.warehouseRepresentiveSignature) {
            setWarehouseRepresentiveSignature(
              report?.warehouseRepresentiveSignature
            );
            setWarehouseRepresentiveSignDate(
              report?.warehouseRepresentiveSignDate
            );
          }

          setPartNumber(partNumber);
          setBatch(batch);
          setIteration(newIteration);
          setStatus(status);
          setSequenceNumber(sequence.toUpperCase());
        }
      );
    }
  }

  const validateItems = (
    inspectionItems: InpectionItem[]
  ): boolean | undefined => {
    if (
      inspectionItems?.some(
        (it) => it.status === InspectionStatusType[InspectionStatusType.Reject]
      )
    ) {
      return false;
    }

    if (
      inspectionItems?.every(
        (it) =>
          it.status === InspectionStatusType[InspectionStatusType.Pass] ||
          it.status === InspectionStatusType[InspectionStatusType.Rework]
      )
    ) {
      return true;
    }
    return undefined;
  };

  const bentTubeCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (bentTubeCheckListItems) {
              const items = [
                ...bentTubeCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setBentTubeCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const preBendCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (preBendCheckListItems) {
              const items = [
                ...preBendCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setPreBendCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const firstCellCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (firstCellMeasurmentCheckListItems) {
              const items = [
                ...firstCellMeasurmentCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setFirstCellMeasurmentCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const lastCellCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (lastCellMeasurmentCheckListItems) {
              const items = [
                ...lastCellMeasurmentCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setLastCellMeasurmentCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const fullBatchCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (fullBatchMeasurmentCheckListItems) {
              const items = [
                ...fullBatchMeasurmentCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setFullBatchMeasurmentCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const postProductionCleaningCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (postProductionCleaningCheckListItems) {
              const items = [
                ...postProductionCleaningCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setPostProductionCleaningCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  return (
    <StyledCncCardVisualInspectionPage>
      {error ? (
        <div className="text-danger">
          <h1>Error: {error}</h1>
        </div>
      ) : (
        <Container fluid>
          <Row align="stretch">
            <h1 style={{ margin: "auto" }}>
              CNC Route Card Visual Inspection Acceptance Report Checklist
              (Batch 2)
            </h1>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PUDSEY TEST REPORT:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={pugseyTestReportNumber}
                placeholder="Scan padsey test report"
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope: ButtonComponent) => {
                  btnPugseyTestReportNumber = scope;
                }}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanPudseyTestClick}
                created={() => {
                  if (btnPugseyTestReportNumber) {
                    btnPugseyTestReportNumber.element.setAttribute(
                      "title",
                      "Scan padsey test report"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>AMOB PRODUCTION NUMBER:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={amobProductionNumber}
                placeholder="Scan amob production number"
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope: ButtonComponent) => {
                  btnAmobProductionNumber = scope;
                }}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanAmobProductionNumberClick}
                created={() => {
                  if (btnAmobProductionNumber) {
                    btnAmobProductionNumber.element.setAttribute(
                      "title",
                      "Scan amob production number"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PART NUMBER:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={partNumber}
                placeholder="Scan part number"
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope: ButtonComponent) => {
                  btnScanPartNumber = scope;
                }}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanPartNumberClick}
                created={() => {
                  if (btnScanPartNumber) {
                    btnScanPartNumber.element.setAttribute(
                      "title",
                      "Scan Part Number"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>HEAT CODE:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={heatCode}
                placeholder="Enter heat code"
                onChange={(args: any) => {
                  setHeatCode(args?.value);
                }}
              />
            </Col>
            {/* <Col sm={1}>
              <ButtonComponent
                ref={(scope) => {
                  btnScanHeatCode = scope;
                }}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanHeatCodeClick}
                created={() => {
                  if (btnScanHeatCode) {
                    btnScanHeatCode.element.setAttribute(
                      "title",
                      "Scan Heat Code"
                    );
                  }
                }}
              />
            </Col> */}
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>SEQUENCE NUMBER:</LabelText>
            </Col>
            <Col>{sequenceNumber}</Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>QUANTITY:</LabelText>
            </Col>
            <Col>
              <NumericTextBoxComponent
                value={quantity}
                min={1}
                onChange={(args: any) => {
                  setQuantity(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>TOOL SIZE:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter tool size"
                value={toolSize}
                onChange={(args: any) => {
                  setToolSize(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>TUBE LENGTH:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter tube lenght"
                value={tubeLenght}
                onChange={(args: any) => {
                  setTubeLenght(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              VERIFICATION OF BENT TUBE SET (CNC & HAND BENT)
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="BentTubeVerificationGrid"
              dataSource={bentTubeCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={270}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={bentTubeCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>Pre-Bend Flush Clean</TitleLabelText>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="PreBendVerificationGrid"
              dataSource={preBendCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={50}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={preBendCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              FIRST OF CELL MEASUREMENT VERIFICATION
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Measurement Report Number:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter measurement report number"
                value={firstCellMeasurementReportNumber}
                onChange={(args: any) => {
                  setFirstCellMeasurementReportNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="firstCellVerificationGrid"
              dataSource={firstCellMeasurmentCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={75}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={firstCellCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              LAST IN THE SEQUENCE MEASUREMENT VERIFICATION
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Measurement Report Number:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter measurement report number"
                value={lastCellMeasurementReportNumber}
                onChange={(args: any) => {
                  setLastCellMeasurementReportNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="lastCellVerificationGrid"
              dataSource={lastCellMeasurmentCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={75}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={lastCellCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              FULL BATCH INSPECTION REQUIRED IF LAST IN SEQUENCE FAILURE
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Measurement Report Number:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter measurement report number"
                value={fullBatchMeasurementReportNumber}
                onChange={(args: any) => {
                  setFullBatchMeasurementReportNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="fullBatchVerificationGrid"
              dataSource={fullBatchMeasurmentCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={75}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={fullBatchCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>POST-PRODUCTION CLEANING CHECKLIST</TitleLabelText>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="postProductionCleaningVerificationGrid"
              dataSource={postProductionCleaningCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              height={175}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={postProductionCleaningCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <Col>
              <LabelText>
                <b>Select recommendation in the box:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <ComboBoxComponent
                value={recommendation}
                disabled={readOnly}
                allowCustom={true}
                width="150"
                dataSource={recomendations}
                popupHeight="150"
                popupWidth="200"
                onChange={(args: any) => {
                  setRecommendation(args.value);
                }}
              ></ComboBoxComponent>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>1.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                The total rejection of the part number sequence, to be remade
                (NCR number added)
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>2.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Partial rejection, remake some of part number sequence.
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>3.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>Local rework</SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>4.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Approval to book into stock to be issued to assemblies
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>INSPECTOR SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{inspectorSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {inspectorSignDate !== undefined
                ? shortDateFormat(inspectorSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>QUALITY REPRESENTATIVE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{qualityRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {qualityRepresentiveSignDate !== undefined
                ? shortDateFormat(qualityRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>WAREHOUSE SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{warehouseRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {warehouseRepresentiveSignDate !== undefined
                ? shortDateFormat(warehouseRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <ButtonComponent
              disabled={!canSumbit}
              style={{ margin: "auto", width: "150px" }}
              cssClass="e-inherit"
              iconCss="e-icons e-save"
              onClick={onSubmit}
            >
              Submit
            </ButtonComponent>
          </Row>
        </Container>
      )}
    </StyledCncCardVisualInspectionPage>
  );
};
